"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpTtl = void 0;
exports.OtpTtl = 5;
